export const isZendeskApp = () => {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}
